// export const routePathWithLanguage = path => `/:lng(de|en)?${path}`
export const routePathWithLanguage = path => `${path}`